
import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useFavorites } from "@/contexts/FavoritesContext";
import { GEAR_CATEGORIES } from "@/lib/gearCategories";

type MobileExploreMenuProps = {
  onClose: () => void;
};

const MobileExploreMenu = ({ onClose }: MobileExploreMenuProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { hasFavorites } = useFavorites();

  const handleCategoryClick = () => {
    setIsExpanded(false);
    onClose();
  };

  return (
    <div>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-between w-full text-lg font-medium text-left py-2"
      >
        Explore
        {isExpanded ? (
          <ChevronUp className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
      </button>

      {isExpanded && (
        <div className="pl-4 space-y-2 pb-2">
          <Link
            key={"all"}
            to={`/explore`}
            className="block text-base font-medium py-1"
            onClick={handleCategoryClick}
          >
            All Equipment
          </Link>
          
          <Link
            to="/explore?view=hybrid&myFavorites=true"
            className={`block text-base font-medium py-1 ${
              !hasFavorites ? 'text-muted-foreground cursor-not-allowed' : ''
            }`}
            onClick={(e) => {
              if (!hasFavorites) {
                e.preventDefault();
              } else {
                handleCategoryClick();
              }
            }}
          >
            My Favorites {!hasFavorites && '(empty)'}
          </Link>
          
          {GEAR_CATEGORIES.map((gear) => (
            <Link
              key={gear.slug}
              to={`/explore?category=${gear.slug}`}
              className="block text-base font-medium py-1"
              onClick={handleCategoryClick}
            >
              {gear.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileExploreMenu;
